<template>
  <div
    class="rt-attr"
    :class="{
      'rt-light': light,
      [`rt-attr-${type}`]: type,
      [`rt-attr-label-${labelPosition}`]: labelPosition,
    }"
  >
    <slot name="label">
      <label
        v-if="label"
        class="rt-attr-label"
        :class="{
          'label-bold': labelBold,
          'label-hidden': labelHidden,
          ['label-' + labelAlign]: labelAlign
        }"
        :style="{
          color: labelColor,
          width: labelWidth
        }"
      >
        <rt-icon
          v-if="labelIconName"
          :name="labelIconName"
          :color="labelIconColor"
          class="label-icon"
        ></rt-icon>
        <span
          class="label-span"
          :style="{
            '-webkit-line-clamp': lineClamp
          }"
        >
          {{ label }}
          <slot
            v-if="labelPosition === 'left'"
            name="splitter"
          >
            {{ splitter || '&nbsp;' }}
          </slot>
        </span>
      </label>
    </slot>
    <slot>
      <span
        v-if="visibleText"
        class="rt-attr-text"
        :class="{
          'text-bold': textBold,
          ['text-' + textAlign]: textAlign
        }"
        :style="{
          color: textColor
        }"
      >
        <rt-icon
          v-if="textIconName"
          :name="textIconName"
          :color="textIconColor"
          class="text-icon"
        ></rt-icon>
        <span
          ref="text"
          class="text-span"
          :class="{
            'text-link': $listeners && $listeners.click
          }"
          :style="{
            '-webkit-line-clamp': lineClamp
          }"
          @click="onTextClick"
        >{{ text }}</span>
      </span>
      <span
        v-else
        class="rt-attr-text text-placeholder"
      >{{
        computedEmptyPlaceholder
      }}</span>
    </slot>
    <slot name="link">
      <div
        v-if="link"
        class="rt-attr-link"
      >
        <a @click="link">{{ $tx('详情', 'xpc.business.attr.detail') }}</a>
        <rt-icon name="rt-base-arrow_right" />
      </div>
    </slot>
  </div>
</template>

<script>
import RtIcon from '../../icon/rtIcon.vue';
import xpcConfig from 'vue-xpc/src/config';

export default {
  name: 'RtAttr',
  deprecatedNames: ['RtText'],
  components: { RtIcon },
  props: {
    type: {
      type: String,
      default: 'sub'
    },
    /**
     * @public label文本
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * @public text文本
     */
    text: {
      type: String,
      default: ''
    },
    link: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    /**
     * @public label前图标
     */
    labelIconName: {
      type: String,
      default: null
    },
    /**
     * @public text前的图标
     */
    textIconName: {
      type: String,
      default: null
    },
    /**
     * @public 文本显示的行数
     */
    lineClamp: {
      type: Number,
      default: 2
    },
    /**
     * @public text前的图标颜色
     */
    labelIconColor: {
      type: String,
      default: 'currentColor'
    },
    /**
     * @public text前的图标颜色
     */
    textIconColor: {
      type: String,
      default: 'currentColor'
    },
    /**
     * @public label是否占位隐藏
     */
    labelHidden: {
      type: Boolean,
      default: false
    },
    /**
     * @public text为空时的提示语
     */
    textPlaceholder: {
      type: String,
      default: ''
    },
    emptyPlaceholder: {
      type: String,
      default: ''
    },
    /**
     * @public label文本颜色
     */
    labelColor: {
      type: String,
      default: null
    },
    /**
     * @public text文本颜色
     */
    textColor: {
      type: String,
      default: null
    },
    /**
     * @public label宽度
     */
    labelWidth: {
      type: String,
      default: null
    },
    /**
     * @public label文本对齐方式
     */
    labelAlign: {
      type: String,
      default: 'left'
    },
    /**
     * @public text文本对齐方式
     */
    textAlign: {
      type: String,
      default: 'left'
    },
    /**
     * @public label文本加粗
     */
    labelBold: {
      type: Boolean,
      default: false
    },
    /**
     * @public text文本加粗
     */
    textBold: {
      type: Boolean,
      default: false
    },
    /**
     * @public 分隔符文本
     */
    splitter: {
      type: String,
      default: ':'
    },
    /**
     * @public label 位置，可选 top
     */
    labelPosition: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    visibleText () {
      return !this.isEmpty(this.text);
    },
    computedEmptyPlaceholder () {
      return this.emptyPlaceholder || this.textPlaceholder || xpcConfig.get('emptyPlaceholder');
    }
  },

  methods: {
    /**
     * @private 派发click事件
     */
    onTextClick () {
      this.$emit('click');
    },
    isEmpty (val) {
      return (val === undefined || val === null || val === '');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAttr.vue?9e4b45e2